/**
 *  @desc 表单必填项定位
 *  @author zh
 *  @date 2022年3月1日
 *  @params formData传入的表单数据对象，rules传入的表单校验规则
*/
export default {
    methods: {
        autoFocus(formData, rules) {
            if (typeof formData !== 'object') return new Error('params formData must be object');
            if (typeof rules !== 'object') return new Error('params rules must be object');
            let isAutoFocus = false;
            for (let key in rules) {
                if (!isAutoFocus) {
                    let isRequired = rules[key].find(item => item.required)
                    if (isRequired) {
                        let keys = key.split('.')
                        if(keys.length > 1) {
                            let obj = formData
                            keys.forEach(item => {
                                obj = obj[item]
                            })
                            if(!obj) {
                                if(this.$refs[key]) {
                                    this.$refs[key].focus();
                                isAutoFocus = true;
                                }
                            }
                        } else {
                            if (!formData[key]) {
                                if(this.$refs[key]) {
                                    this.$refs[key].focus();
                                isAutoFocus = true;
                                }
                            }
                        }
 
                    }
                } else {
                    break 
                }
            }
            return isAutoFocus
        },
    }
}